import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./NotificationsPage'))

class AsyncNotificationsPage extends AsyncPage {
  nonav = true
  
  constructor() {
    super({
      title: 'navigation./notifications',
      pageComponent: component
    })
  }
}

export default new AsyncNotificationsPage()
